"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PlaidConnectFlow/shared/PlaidSecurityBadge";

import React from "react";
import { Icon } from "@ospweb/sdk-ui";

const I18n = I18nUtil.createScoped(Translations);

export interface PlaidSecurityBadgeProps {
  className?: string;
  variant?: "standard" | "compact";
}

export const PlaidSecurityBadge: React.FC<PlaidSecurityBadgeProps> = ({
  className = "",
  variant = "standard",
}) => {
  if (variant === "compact") {
    return (
      <div
        className={`flex items-center justify-center gap-1.5 py-3 text-xs text-content_tertiary select-none ${className}`}
      >
        <Icon
          name="lock-alt-fill"
          size={14}
          className="text-content_tertiary shrink-0"
        />
        <span>{I18n.t("Secured by Plaid • End-to-end encrypted")}</span>
      </div>
    );
  }

  return (
    <div
      className={`flex gap-2 items-start text-content_tertiary select-none ${className}`}
    >
      <div className="size-4 shrink-0 mt-0.5 flex items-center justify-center text-content_tertiary">
        <Icon name="lock-alt-fill" size={16} />
      </div>
      <p className="text-xs leading-4 text-content_tertiary font-normal [word-break:break-word]">
        {I18n.t(
          "Read-only. I can see balances and holdings, never move money. Connected securely through Plaid. Unlink anytime.",
        )}
      </p>
    </div>
  );
};
